import { TwirpErrorCode } from "@protobuf-ts/twirp-transport"
import { Any as AnyPb } from "gen/google/protobuf/any_pb"

import { logger } from "../logger"
import { isStringOrStringArrayMap } from "../utils/guards/guards"

import type { RpcError } from "@protobuf-ts/runtime-rpc"

const apiErrorLogger = logger.withScope("apiError")

export interface ApiError
  extends Error,
    Pick<RpcError, "methodName" | "serviceName" | "meta"> {
  code: keyof typeof TwirpErrorCode
  protoError?: AnyPb // Empty until extracted from encoded meta.protoAnyError
}

export function isApiError(error: unknown): error is ApiError {
  return (
    Boolean(error) &&
    // RpcError extends Error
    error instanceof Error &&
    // Valid Twirp error code
    "code" in error &&
    typeof error.code === "string" &&
    error.code in TwirpErrorCode &&
    // Required picked RpcError attributes
    "meta" in error &&
    isStringOrStringArrayMap(error.meta)
  )
}

/** Gets API provided user friendly message in meta.userMessage */
export const getUserMessage = ({
  meta: { userMessage },
}: ApiError): string | undefined => {
  if (userMessage === undefined) return undefined // can be omitted

  // Log invalid usages of userMessage
  if (typeof userMessage !== "string") {
    apiErrorLogger.warn(
      "ApiError meta.userMessage is set to a non-string; informational components will display a default message",
      { userMessage }
    )
    return undefined
  }

  if (userMessage.length === 0) {
    apiErrorLogger.warn(
      "ApiError meta.userMessage is set to the empty string; informational components will display a default message",
      { userMessage }
    )
    return undefined
  }

  return userMessage
}
